import { Theme, Typography, FormControl, FormHelperText, Card, InputAdornment, IconButton } from '@material-ui/core';
import React, { useState } from 'react';
import { matchDispatchToProps } from '../../redux/actions/AuthActions';
import { connect } from 'react-redux';
import { Formik, Form, FormikState } from 'formik';
import * as Constants from '../../constants';
import * as Service from '../../services';
import * as Yup from 'yup';
import InputField from '../../components/InputField';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { formState, userState, successfulRequest } from './SignInModel';
import Logo from '../../resources/images/logo-automedsys.png';
import { useStyles } from './styles';
import Button from '../../components/Button';
import { ClassNameMap } from '@material-ui/styles';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import ChangePasswordModal from '../components/ChangePasswordModal';
import { Color } from '@material-ui/lab/Alert';
import { changeUserPassword } from '../../services/Users';
import { errorHandler, parseAccountType, setItemStore } from '../../Utilities/appHelpers';

//Y=>Snippest copied from redirectDash, is just to make it exportable so that the function can be reused
export const UpdateStorage = (res: Record<string, any>) => {
   //console.log(res);
   setItemStore('AUTOMEDSYS_TOKEN', res.data.Token);
   //Y=>Get the idletime comming from api and keep it
   /*********************************************** */
   setItemStore('AUTOMEDSYS_IDLE', res.data.IdleTimeout);
   /*********************************************** */
   setItemStore('AUTOMEDSYS_R', JSON.stringify(res.data.Data.PracticeInformation.Address));
   setItemStore('AUTOMEDSYS_PRACREF', res.data.Data.PracticeInformation.PracticeReferenceNumber);
   setItemStore('AUTOMEDSYS_PRACNAME', res.data.Data.PracticeInformation.OrganizationName);
   setItemStore(
      'AUTOMEDSYS_USERNAME',
      `${res.data.Data.UserInformation.Name.FirstName} ${res.data.Data.UserInformation.Name.LastName}`,
   );
   setItemStore('AUTOMEDSYS_USERINFO', JSON.stringify(res.data.Data.UserInformation));
   setItemStore('AUTOMEDSYS_ID', res.data.Data.UserInformation.RecordId);

   if (res.data.Data.ProviderInformation.UniqueId) {
      setItemStore('AUTOMEDSYS_PR', JSON.stringify(res.data.Data.ProviderInformation));
   }
};

const SignIn = (props: any) => {
   const initialValues = {
      Username: '',
      Password: '',
      PracticeRefNumber: '',
   };
   const history = useHistory();

   const validationSchema = Yup.object({
      Username: Yup.string()
         .required('Username is empty!')
         .min(2, 'Username should not be less than 2 characters')
         .max(35, 'Exceeded maximum character length'),
      Password: Yup.string().required('Password is empty'),
      PracticeRefNumber: Yup.string()
         .required('Practice ID is empty')
         .min(5, 'Practice ID should not be less than 5 characters')
         .max(70, 'Exceeded maximum character length'),
   });

   interface userProps {
      firstName: string;
      lastName: string;
      username: string;
      role: string;
      accountType: string;
      userId: string;
   }

   const classes: ClassNameMap = useStyles();
   const [showPassword, setShowPassword] = useState(false);
   const [isSuccessful, setIsSuccessful] = useState<successfulRequest>();
   const [openPasswordModal, setOpenPasswordModal] = useState<boolean>(false);
   const [userDetails, setUserDetails] = useState<Record<string, any>>({});

   const [user, setUser] = useState<userProps>({
      firstName: '',
      lastName: '',
      username: '',
      role: '',
      accountType: '',
      userId: '',
   });

   const [alertColor, setAlertColor] = useState<Color | undefined>();
   const [alertMessage, setAlertMessage] = useState<string>('');
   const [showAlert, setShowAlert] = useState<boolean>(false);

   const handleClickShowPassword = () => {
      setShowPassword(!showPassword);
   };

   const handleMouseDownPassword = (event: any) => {
      event.preventDefault();
   };

   // const handleUpdatePassword = (values: Record<string, any>) => {
   //    console.log(values);
   // };

   const handleUpdatePassword = async (
      values: Record<string, any>,
      setSubmitting: (isSubmitting: boolean) => void,
      resetForm: (nextState?: Partial<FormikState<any>> | undefined) => void,
   ) => {
      const newValue = {
         OldPassword: values.currentPassword,
         NewPassword: values.newPassword,
      };
      try {
         await changeUserPassword(Constants.AUTH, Constants.USERS, Constants.PASSWORD, newValue);
         setAlertMessage('Password has been changed successfully');
         setAlertColor('success');
         setShowAlert(true);
         setOpenPasswordModal(false);
         redirectToDash(userDetails, true);
      } catch (err) {
         errorHandler(err);
         clearLocalStorage();
      }
   };

   const redirectToDash = async (res: Record<string, any>, redirect: boolean) => {
      // setAxiosHeader(res.data.Token);
      try {
         UpdateStorage(res);

         const permissionsRes: any = await Service.getList(Constants.AUTH, Constants.PERMISSIONS);

         if (permissionsRes.status === 200) {
            setItemStore('AUTOMEDSYS_ACCESS', JSON.stringify(permissionsRes.data.ResponseData));
         }

         redirect && history.push({ pathname: '/dashboard', state: res.data.Data.PracticeInformation.FirstTimeAccess });
      } catch (error: any) {
         errorHandler(error);
      }
   };

   const clearLocalStorage = () => {
      sessionStorage.clear();
      setOpenPasswordModal(false);
   };

   const onSubmit = async (values: formState) => {
      try {
         const res = await Service.userLogin(values, Constants.IDENTITY, Constants.CONNECT_TOKEN);
         if (res.status === 200) {
            //Y=>Keep the username(email) in local storage
            //************************************ */
            setItemStore('AUTOMEDSYS_LUN', values.Username);

            //************************************ */
            if (res.data.Data.RequiresPasswordReset) {
               setOpenPasswordModal(true);
               setUserDetails(res);
               redirectToDash(res, false);
               const loggedInUser = {
                  firstName: res.data.Data.UserInformation.Name.FirstName,
                  lastName: res.data.Data.UserInformation.Name.LastName,
                  username: res.data.Data.UserInformation.Email,
                  role: '',
                  accountType: parseAccountType(Constants.accountTypeEnum.provider),
                  userId: res.data.Data.UserInformation.RecordId,
               };
               setUser(loggedInUser);
            } else {
               redirectToDash(res, true);
            }
         }
      } catch (error: any) {
         const message = error.response.data.UserErrorMessage;

         if (message) {
            toast.error(message, {
               position: toast.POSITION.TOP_RIGHT,
               autoClose: 5000,
            });
         } else {
            toast.error('Request Failed, Please Try Again!', {
               position: toast.POSITION.TOP_RIGHT,
               autoClose: 5000,
            });
         }

         setIsSuccessful({
            status: false,
            message:
               message === 'Invalid Username or wrong password'
                  ? 'Invalid Username or Password. Please Try Again!'
                  : message,
         });
      }
   };

   return (
      <>
         <div
            style={{
               display: 'flex',
               justifyContent: 'center',
            }}
         >
            <img className={classes.img} src={Logo} id="loginImage" alt="company Logo" />
         </div>

         <Card className={classes.root}>
            <div className={classes.header}>
               <Typography className={classes.cta}>Login</Typography>
               <Typography variant="body1">Enter Login details to proceed</Typography>
            </div>

            <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
               {({ values, errors, touched, getFieldProps, isSubmitting, submitCount }) => (
                  <Form noValidate autoComplete="off">
                     <FormControl className={classes.formControl}>
                        <InputField
                           className={classes.outline}
                           id="Username"
                           label="Username"
                           {...getFieldProps('Username')}
                           type="text"
                           variant="outlined"
                           error={errors.Username && touched.Username ? true : false}
                           helperText={errors.Username && touched.Username ? errors.Username : null}
                           inputProps={{
                              maxLength: 35,
                           }}
                        />
                     </FormControl>

                     <FormControl className={classes.formControl}>
                        <InputField
                           className={classes.outline}
                           id="Password"
                           label="Password"
                           {...getFieldProps('Password')}
                           type={showPassword ? 'text' : 'Password'}
                           variant="outlined"
                           error={errors.Password && touched.Password ? true : false}
                           helperText={errors.Password && touched.Password ? errors.Password : null}
                           InputProps={{
                              endAdornment: (
                                 <InputAdornment position="end">
                                    <IconButton
                                       aria-label="toggle Password visibility"
                                       onClick={handleClickShowPassword}
                                       onMouseDown={handleMouseDownPassword}
                                       edge="end"
                                    >
                                       {showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                 </InputAdornment>
                              ),
                           }}
                        />
                     </FormControl>

                     <FormControl className={classes.formControl}>
                        <InputField
                           className={classes.outline}
                           id="PracticeRefNumber"
                           label="Practice ID"
                           {...getFieldProps('PracticeRefNumber')}
                           type="text"
                           variant="outlined"
                           error={errors.PracticeRefNumber && touched.PracticeRefNumber ? true : false}
                           helperText={
                              errors.PracticeRefNumber && touched.PracticeRefNumber ? errors.PracticeRefNumber : null
                           }
                           inputProps={{
                              maxLength: 35,
                           }}
                        />
                     </FormControl>
                     <FormControl className={classes.formControl}>
                        <Button
                           variant="contained"
                           color="primary"
                           type="submit"
                           disabled={isSubmitting}
                           loading={isSubmitting}
                        >
                           Login
                        </Button>
                     </FormControl>
                     <FormControl className={isSuccessful?.status === false ? classes.formControl : ''}>
                        <FormHelperText style={{ textAlign: 'center', fontSize: '1rem' }} error={true}>
                           {isSuccessful?.status === false
                              ? isSuccessful.message
                                 ? isSuccessful.message
                                 : 'an error occured'
                              : null}
                        </FormHelperText>
                     </FormControl>
                  </Form>
               )}
            </Formik>
            <ChangePasswordModal
               open={openPasswordModal}
               setOpen={setOpenPasswordModal}
               handleSubmit={handleUpdatePassword}
               userfirstname={user.firstName}
               userlastname={user.lastName}
               username={user.username}
               userRole={user.role}
               userAccountType={user.accountType}
               userId={user.userId}
               resetPassword={true}
               setAlertColor={setAlertColor}
               setAlertMessage={setAlertMessage}
               setShowAlert={setShowAlert}
            />
         </Card>
      </>
   );
};

export default SignIn;
